import React from 'react'
import { PropTypes } from 'prop-types'
import Filter from '../Filter';
import Cart from '../Cart';
import Products_Component from '../Products_Component';
import { connect } from 'react-redux';
import LoadingHook from '../hooks/LoadingHook';


class HomeScreen extends React.Component {
    render() {
        
        return (

            <div className='content'>
                <div className="main">
                    <Filter />
                    {
                        this.props.userState?.loading && <LoadingHook />
                    }
                    <Products_Component />
                </div>

                <div className="sidebar">
                    <Cart history={this.props.history} />
                </div>
            </div>

        );

    }
    
}

HomeScreen.propTypes = {
    userState: PropTypes.object,
    history:PropTypes.object,
    // Action_user_login_passport:PropTypes.func,
}

export default connect((state) => ({
    userState: state.reducer_user
}),
    {
        // Action_user_login_passport,

    }
)(HomeScreen)
